/* 
Check if the user is on a mobile device
*/
function isMobileDevice() {
  return /Mobile|iPhone|iPad|Android|Windows Phone|BlackBerry|Opera Mini/i.test(navigator.userAgent);
}


$(document).ready(function(){
 
  // Show the PDF container on catalogue click
  $('.catalogue-column .multicolumn-card__image-wrapper').on('click', function(){
    $('.pdf-container').show();
  })

  // Hide the PDF container on close
  $('.close').on('click', function(){
      $(this).parent().hide();
  })


  // Set the product colors containers placement on archive page
  var card_prod_height = $('.grid__item .card__media').height();
  var inner_item = document.querySelector('.grid__item .card__inner');
  var inner_item_height;
  if (inner_item) {
    inner_item_height = inner_item.offsetHeight-60;
  }
  card_prod_height = card_prod_height - 40;

  // Replace '.grid__item' with the actual class name or ID you're targeting
  var gridItem = document.querySelector('.grid__item');
  
  if (gridItem) {
    var card_prod_height = $('.grid__item .card__media').height();

    if ( isMobileDevice() || window.innerWidth < 500) {
        card_prod_height = card_prod_height;
        console.log(inner_item_height);
        
        var elements = document.querySelectorAll('.version-two-color');
        elements.forEach(function(element) {
          the_prod.setAttribute('style', "top:"+inner_item_height+'px !important;');
        });

      console.log('MOBILE');
    } else {
        
      $('.version-two-color').css('top', inner_item_height+'px');

      console.log('BIG DEVICE');
    }
  } 

  // Changes the product details on color change on collection page
  setTimeout(() => {
    $('.color-selection.collection a img, .color-selection.collection .color_swatch').on('click', function(){
      console.log('CHANGE URL');
      var prodUrl = jQuery(this).attr('data-url');
      var prodImage = jQuery(this).attr('data-img');
      var newPrice = $(this).attr('data-price');
      var oldPrice = $(this).attr('data-old-price');
      var newTitle = $(this).attr('data-title');

      console.log('Title: '+newTitle);

      newPrice = parseFloat(newPrice).toFixed(2);
      oldPrice = parseFloat(oldPrice).toFixed(2);
      
      // Change the image 
      $(this).parents('li.grid__item').find('.card__content .card__heading a').attr( 'href', $(this).data('url') );
      $(this).parents('li.grid__item').find('.card__media img').attr( 'src', $(this).data('img') );
      $(this).parents('li.grid__item').find('.card__media img').attr( 'srcset', $(this).data('img') );
      
      // Set the new selecteed class
      $(this).parent().parent().find('a.selected').removeClass('selected');
      $(this).parent().addClass('selected');

      // Change the text
      $(this).parents('li.grid__item').find('.full-unstyled-link').text(newTitle);

      // Change the price
      $(this).parents('li.grid__item').find('.card-information span.price-item.price-item--old').html('<span class="price-item price-item--old">'+oldPrice+' kr</span>');
      $(this).parents('li.grid__item').find('.card-information span.price-item.price-item--regular').html('<span class="price-item price-item--regular">'+newPrice+' kr</span>');
    });
  }, 1200);
 
  // Create hover function for mega-menu
  // $('details.mega-menu').hover(
  //   function() {
  //     $( this ).attr( 'open', true );
  //   }, function() {
  //     $( this ).removeAttr('open');
  //   }
  // );


  // Render the products colors on collection page
  //render_reference_products();
  //get_current_collection_sold_out_prodcuts();

});
 
// Function that renders the product colors on the collection page 
function render_reference_products(){
  console.log('Info: Render product');
  // var product_handle_objects = get_reference_products();

  $('li.grid__item').each(function(){
    var colorContainer      = $(this).find('.color-selection');
    var main_id             = $(colorContainer).attr('data-main-id');
    var selected_handle     = $(colorContainer).attr('data-selected-handle');
    var color_version       = $(colorContainer).attr('data-color-version-two');
    var check_offer_number  = $(this).get(0).hasAttribute('data-offer-number') ? parseInt( $(this).attr('data-offer-number') ) : 0;
    
    var handleArr = [];
    handleArr.length = 0;
    handleArr.push($(colorContainer).attr('data-selected-handle')+'|'+$(colorContainer).attr('data-related-handles') );
    
    if( handleArr == null ){
      console.log('Info: No products in stored data 1');
      return;
    }else{
      console.log('Info: Reindexing products 1');
      //jQuery(colorContainer).html('');
    }
 
    var splitCookie = handleArr[0].split('|');
    var list = jQuery(colorContainer);
    var productArr = [];
    productArr.length = 0;
    // Get normal productinfo
    
    for( i = 0; i < splitCookie.length; i++ ){
      if (typeof splitCookie[i] === 'string') {
        let parts = splitCookie[i].split('_');
        let url = '/products/' + parts[0] + '.js';

        jQuery.getJSON(url, function(product) {

          let prod_obj ={
           prod: product,
           color: parts[1]
          }
           productArr.push(prod_obj);
         })
         .done(function(product) {
           console.log( "Success" );
           
         })
         .fail(function() {
           console.log( "error: No handle found" );
         });
      }

      
    }

    setTimeout(() => {
      if( productArr.length == 0 ){
          console.log('Info: No products in stored data');
          return;
      }else{
          console.log('Info: Reindexing products');
      }
      
      productArr.forEach(element => {
        var the_prod    = element.prod; 
        var color_image  = element.color;

        // Check tags to see what color the product is.
        // This is used if no color is set in metafields
        // This will need to be dynamic in the future, when PIM is in engish

      
        if(!color_image){
          for( var tag of the_prod.tags ){
            var color_group;
            if( tag.toLowerCase().indexOf('bicolor') > 0 || tag == 'Metal_Bicolor' || tag == 'Bicolor'){
              color_image =  color_version ? 'linear-gradient(54deg, rgba(214,214,214,1) 49%, rgba(216,200,151,1) 49%)' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_bicolor.png';
              color_group = 'cw_bicolor';
              break;
            }
            if(tag.toLowerCase().indexOf('sølv') > 0 ||  tag == 'Metal_Sterlingsølv' || tag == 'Sterlingsølv' || tag.toLowerCase().indexOf('silber') > 0){
              color_image =  color_version ? '#d6d6d6' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_silver.png';
              color_group = 'cw_silver';
              break;
            }
            if( tag.toLowerCase().indexOf('Rosa ') > 0 ||  tag == 'Metal_Rosa' || tag == 'Rosa' || tag == 'Rosaforgyldt' || tag.toLowerCase().indexOf('rosa') > 0){
              color_image =  color_version ? '#f1d2c5' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_rosa.png';
              color_group = 'cw_rosa';
              break;
            }
            if( tag.toLowerCase().indexOf('forgyldt') > 0 ||  tag == 'Metal_Forgyldt' || tag == 'Forgyldt' || tag.toLowerCase().indexOf('vergoldet') > 0){
              color_image =  color_version ? '#d8c897' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_gold.png';
              color_group = 'cw_gold';
              break;
            }
            
            if(tag.toLowerCase().indexOf('Ruthenium') > 0 ||  tag == 'Metal_Rutheniumbelagt' || tag == 'Rutheniumbelagt'){
              color_image =  color_version ? '#666' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_black.png';
              color_group = 'cw_black';
              break;
            }
          }
        }
        
        var featured_image = the_prod.featured_image;
        var flip_image = the_prod.images[1];
        var is_selected = 'not-selected';

        // Set class for selected element
        if(the_prod.handle == selected_handle){
          var is_selected = 'selected';
        }

        // Check if the product is on sale and create a new price if true
        if( check_offer_number != 0 ){
          var saved_amount = (the_prod.price/100)*check_offer_number;
          var element_price = (the_prod.price-saved_amount);
          var old_price = the_prod.price.toFixed(2)/100;
          element_price = element_price.toFixed(2)/100;
        }else{
          var element_price = the_prod.price.toFixed(2)/100;;
        }

        // Refresh html element
        html = '';
        if( color_version ){
          if( typeof(color_image) == 'undefined' ){
            color_image = '#d6d6d6';
          }

          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<div '+'style="background:'+color_image+';" color="'+color_image+'" class="color_swatch fittingbox-select"'+ 
              'data-id="'+the_prod.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+the_prod.title+'" data-url="/products/'+the_prod.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+the_prod.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+the_prod.handle+'">'+
              '</div>'+
          '</a>';
        }else{
          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<img '+'src="'+color_image+'" class="color_swatch fittingbox-select" data-frame="{{ product_frame }}"'+ 
              'data-id="'+the_prod.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+the_prod.title+'" data-url="/products/'+the_prod.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+the_prod.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+the_prod.handle+'"'+
              '/>'+
          '</a>';
        }
        
        i++;
        $(list).append(html);
      });
    }, 900);
  });
}

// Function that retrieves the current collection sold out productsz
function get_current_collection_sold_out_prodcuts(){
  if( $('#sold-out-collection').length > 0){
    setTimeout(() => {
      
      // Get url parameters to check page number
      const queryString         = window.location.search;
      const urlParams           = new URLSearchParams(queryString);
      const page_param          = urlParams.get('page')
      const sold_out_container  = document.querySelector("#sold-out-collection");
      const max_page            = sold_out_container.dataset.pagesize; 
      const offer_collection    = "";
      const offer_number        = 50;
      
      // Check if we are on the last page og pagination
      if( page_param == max_page || max_page == 1 ){
        // Call the function with the collection handle and API access token
        getProductsInCollection(location.pathname, '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')
        .then(products => {
          // Loop through the array of products and do something with each one
          var html      = "";
          for (let i = 0; i < products.length; i++) {
            // Assign the individual product
            const product = products[i];
            const variant_count = product.variants.length;
            var splash    = "";
            
            // Get the text for the splashes
            if ( product.tags.includes("4 mm") && product.product_type == "Charms" ) {
              splash = '<div data-first-splash="true" class="grid-product__tag grid-product__tag--plus-size first-splash splash-design-round" style="background-color:#a3a1a1; color: #ffffff;font-size:12px; ">'+
              '<p>Til slimlæder &amp; <br>sølvarmbånd</p>'+
              '</div>';
            }
            if ( product.tags.includes("6 mm") && product.product_type == "Charms" ) {
              splash = '<div data-second-splash="true" class="grid-product__tag grid-product__tag--second-tag second-splash splash-design-round move-down" style="background-color:#000000; color: #ffffff;font-size:12px;  ">'+
              '<p>Til Classic <br>læderarmbånd</p>'+
              '</div>';
              
            }
            
            console.log('number of variants: '+variant_count);
            // Check if the product is available
            if (variant_count <= 1) {
              for (let n = 0; n < product.variants.length; n++) {
                const variant = product.variants[n];
                var featured_image = "https://cdn.shopify.com/s/files/1/0821/7454/2143/files/logo.png?v=1693904133";
                if (product.images[0] && product.images[0].src ) {                  
                  featured_image = product.images[0].src;
                }
          
                if (variant.available == false ) {
                  html += '<li class="grid__item custom__grid" data-handle="'+product.handle+'">'+
                    '<div class="card-wrapper underline-links-hover">'+
                      '<div class="card card--standard  card--media" style="--ratio-percent: 100%;">'+
                        '<div class="card__inner innder_card22 color-background-2 gradient ratio" style="--ratio-percent: 100%;">'+
                          splash+
                          '<div class="card__media" style="width:100%">'+
                            '<div class="media media--transparent media--hover-effect">'+
                              '<img style="object-fit: contain;" src="'+featured_image+'" alt="You and Me Charms til sølvarmbånd - Sandgaard" class="motion-reduce main-image" width="2000" height="2000">'+
                            '</div>'+
                          '</div>'+
                          '<div class="card__content">'+
                            '<div class="card__information">'+
                              '<h3 class="card__heading">'+
                                '<a href="/products/'+product.handle+'" id="" class="full-unstyled-link main-product-link"">'+product.title+'</a>'+
                              '</h3>'+
                            '</div>'+
                            '<div class="card__badge top right"><span class="badge font-weight-500 color-grey">Udsolgt</span></div>'+
                          '</div>'+
                        '</div>'+
                        '<div class="card__content">'+
                          '<div class="card__information">'+
                            '<h3 class="card__heading h5" id="">'+
                              '<a href="/products/'+product.handle+'" id="" class="full-unstyled-link" aria-labelledby="">'+product.title+'</a>'+
                            '</h3>'+
                          '<div class="card-information">'+
                            '<div class="price  price--sold-out " data-offer-collection="'+offer_collection+'" data-offer-number="'+offer_number+'">'+
                              '<div class="price__container">'+
                                '<div class="price__old" style="display:none;">'+
                                  '<span class="price-item price-item--old">'+variant.price+'</span>'+
                                '</div>'+
                                '<div class="price__regular">'+
                                  '<span class="price-item price-item--regular">'+variant.price+'</span>'+
                                '</div>'+
                              '</div>'+
                            '</div>'+
                          '</div>'+
                        '</div>'+
                      '</div>'+
                    '</div>'+
                  '</li>';
                }
              }
            }
            
          }
          $(sold_out_container).append(html);
        })
        .catch(error => console.error(error));
      }
    }, 500);
  }
}

/**
 * Recursive funtion to get all products in a current collection
 * @param {*string} collectionHandle 
 * @param {*string} accessToken 
 * @param {*array} products 
 * @param {*Int} page 
 * @returns 
 */
function getProductsInCollection(collectionHandle, accessToken, products = [], page = 1) {
  return fetch(`${collectionHandle}/products.json?limit=50&page=${page}&access_token=${accessToken}`)
  .then(response => response.json())
  .then(productsPage => {
    // Concatenate the new products with the previous ones
    products = products.concat(productsPage.products);

    // Check if there are more products available
    if (productsPage.products.length === 50) {
      // Recursively call the function to get the next page of products
      return getProductsInCollection(collectionHandle, accessToken, products, page + 1);
    } else {
      // Return the final list of products when there are no more pages
      return products;
    }
  })
  .catch(error => console.error(error));
}

/**
 * Returns data in a specific collection
 * @param {*String} access_token 
 * @param {*String} domain 
 * @param {*String} product_handle 
 */
function return_product_collection(access_token, domain, product_handle){
  console.log('gettings collections');
  const client = ShopifyBuy.buildClient({
    storefrontAccessToken: access_token,
    domain: domain
  });
  
  client.product.fetchByHandle(product_handle).then(product => {
    const collectionEdges = product.collections.edges;
    const collections = collectionEdges.map(edge => edge.node);

  }).catch(error => console.error(error));
}


$('.iframe-full-height').on('load', function(){
  this.style.height=this.contentDocument.body.scrollHeight +'px';
});

/**
 * Function to get metafild values
 * @param {*string} handle 
 * @param {*string} namespace 
 * @param {*string} key 
*/
function get_metafield_value(handle, namespace, key) {
  const url = "https://sandgaard-studio-clothing.myshopify.com/api/2022-01/graphql.json";
  const storefrontAccessToken = 'cfe2d8c03c4b734d24842840b632f1de';
  const query = `
  {
    productByHandle(handle: "${handle}") {
      title
      metafield(namespace: "${namespace}", key: "${key}") {
        value
      }
    }
  }
  `;

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: query
  })
  .then(response => response.json())
  .then(data => {
      const metafieldValue = data.data.productByHandle.metafield.value;
      return metafieldValue;
  });
}


/**
 * Controls the inventory data. It sets an item as outof stock and sets the stock text
 * @param {*string} value 
 */
function product_inventory_functionality(value) {

  // The container which hold the initial data
  // like {{product.handle}}, {{product.id}} etc
  const element_data = document.querySelector('.product__info-container');
  
  if (!element_data) return;

  let default_variant = element_data.getAttribute('data-only-default') === 'true';
  const initial_id = element_data.getAttribute('data-id');
  const parent_handle = element_data.getAttribute('data-product-handle');
  
  if (typeof value === "undefined") {
    default_variant = true;
  }

  // Fetch the product data - Check for variant values
  fetch(`/products/${parent_handle}.js`)
  .then(response => response.json())
  .then(product => {
      let variant_id;
      
      if (!default_variant) {
        const variant = product.variants.find(v =>
          v.option1 === value || 
          v.option2 === value || 
          v.option3 === value
        );
        
        if (variant) {
          variant_id = variant.id;
        }
      } else {
        variant_id = initial_id;
      }

      const inventory_element = document.getElementById('inventory-element');
      
      if (inventory_element) {
        const colorElement = inventory_element.querySelector('.inventory-color');
        const textElement = inventory_element.querySelector('.inventory-text');
        
        if (check_stock_status(product.id, variant_id)) {
          if (colorElement) {
            colorElement.classList.add('in-stock');
            colorElement.classList.remove('out-of-stock');
          }
          if (textElement) textElement.innerText = "På lager";
        } else {
          if (colorElement) {
            colorElement.classList.add('out-of-stock');
            colorElement.classList.remove('in-stock');
          }
          if (textElement) textElement.innerText = "I restordre - Forvent længere leveringstid";
        }
      }
  })
  .catch(error => console.error('Error fetching product:', error));
}


/**
 * Check stock status 
 * THis does not work unless commented script below is present on product page
 * It also needs the foreach radio-btn 
 * @param {*string} productId 
 * @param {*string} variantId 
 * @returns true if in stock
 */
function check_stock_status(productId, variantId) {
  console.log('Inside check');
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const quantity = window.inventories[productId][variantId].quantity;
      console.log('Quantity: '+ quantity);
      console.log(quantity > 0);
      return quantity > 0;
  }
  return false;
}
 
/**
 * Output inventorydata
 * @param {*string} productId 
 * @param {*string} variantId 
 */
function display_inventory_data(productId, variantId) {
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const inventory = window.inventories[productId][variantId];
      console.log("Quantity:", inventory.quantity);
      console.log("Policy:", inventory.policy);
      console.log("Incoming:", inventory.incoming);
      console.log("Next Incoming Date:", inventory.next_incoming_date);
  } else {
      console.log("No inventory data found for the specified product and variant.");
  }
}

/**
 * Implements hotspot functionality for product-hot-spot section
 */
function hotspot_functionality(){
  //var hotspot = querySelector('.hotspot-item'); 
  document.querySelectorAll('.hotspot-item').forEach(function(item) {
    item.addEventListener('click', function(event) {
        // Getting the 'data-id' attribute from the hotspot item
        const hotspotDataId = item.getAttribute("data-id");
        console.log(hotspotDataId);
        if (!hotspotDataId) {
            console.error('Data ID not found in hotspot item.');
            return;
        }
  
        try {
            // Extracting information with null checks
            const imgElement = item.querySelector('img');
            const preview_image = imgElement ? imgElement.getAttribute('src') : 'DefaultImagePath';
  
            const linkElement = item.querySelector('a');
            const url = linkElement ? linkElement.getAttribute('href') : 'DefaultURL';
  
            const contentElement = item.querySelector('.product-title');
            const content = contentElement ? contentElement.innerText : 'DefaultContent';
  
            const priceElement = item.querySelector('.prod-price');
            const price = priceElement ? priceElement.innerText : 'DefaultPrice';
  
            // Finding the '.side-product' container corresponding to this data-id
            var target_container = document.querySelector('.side-product-section-' + hotspotDataId);
            if (!target_container) {
                console.error('Side product container for data-id ' + hotspotDataId + ' not found.');
                return; // Exit the function if the container is not found
            }
  
            // Updating elements within the '.side-product' container
            var target_image = target_container.querySelector('#side-product__preview-image');
            if (target_image) {
                target_image.src = preview_image;
            } else {
                console.error('Preview image element not found.');
            }
  
            var target_url = target_container.querySelector('.button');
            if (target_url) {
                target_url.href = url;
            } else {
                console.error('URL element not found.');
            }
  
            var target_content = target_container.querySelector('.title');
            if (target_content) {
                target_content.innerText = content;
            } else {
                console.error('Content element not found.');
            }
  
            var target_price = target_container.querySelector('.price span');
            if (target_price) {
                target_price.innerText = price;
            } else {
                console.error('Price element not found.');
            }
  
        } catch (error) {
            console.error('An error occurred:', error);
        }
    });
  });
  
}


/**
* Used to create the pop-up content when a user clicks the PDF item
* HTML can be found in theme.liquid
* @param {*string} id 
*/
function add_to_cart_content(id_arr){

  $('#add-to-cart-container').show();
  var item_handle_arr = id_arr;
  //item_handle_arr.split(',');
  console.log('HEJ ', item_handle_arr);
  //item_sku = id_arr.split(','); // Get the part before the slash
 
  for (let index = 0; index < id_arr.length; index++) {
    const element = id_arr[index];
    console.log(element);

    $.ajax({
        url: '/products/'+element+'.js',
        method: 'GET',
        dataType: 'json'
    })
    .then(response => {
      // Handles the response - Insert data into elements 
      // var price   = response.price/100;
      // var element = document.getElementById('#the-look-item-rrp');
      // $('.b2b-add-to-cart-content').html('');
      // $('div#add-to-cart-content .right-col').show();
      // $('div#add-to-cart-content .right-col.error-col').hide();
      // $('#the-look-item-variants').html("");
      // $('#the-look-item-img').html('<img src="'+response.featured_image+'" >');
      // $('#the-look-item-title').html(response.title);
      // $('#the-look-item-price').html(price+',- DKK');
      
      html += 
      '<div class="left-col">'+
        '<div id="the-look-item-img"></div>'+
      '</div>'+
      '<div class="right-col">'+
        '<h2><div id="the-look-item-title" class="b2b-add-to-cart-content"></div></h2>'+
        '<div id="the-look-item-price" class="b2b-add-to-cart-content"></div>'+
        '<div id="the-look-item-variants" class="b2b-add-to-cart-variants js product-form__input"></div>'+
        '<div id="the-look-item-quantity"></div>'
        '<div class="b2b-quantity product-form__input product-form__quantity" >'
          '<label class="form__label" for="Quantity-catalogue">'
            
          '</label>'

         ' <quantity-input class="quantity">'
            '<button class="quantity__button no-js-hidden" name="minus" type="button">'
              
            '</button>'
            '<input class="quantity__input" type="number" name="quantity" id="Quantity-catalogue" min="1" step="1" value="1" form="{{ product_form_id }}" >'
            '<button class="quantity__button no-js-hidden" name="plus" type="button">'
              
            '</button>'
          '</quantity-input>'
        '</div>'
      '</div>'
      '<div id="add-to-cart-btn" class="button button--primary">'
       ' Add to cart'
      '</div>'
      '<div id="the-look-item-inventory" class="js-product-inventory-data b2b-add-to-cart-content"></div>'
      '<div id="the-look-item-status" class="b2b-add-to-cart-content"></div>'
      '<div id="the-look-item-rrp" class="b2b-add-to-cart-content"></div>'
      '<h4 style="margin-top:0"><div id="the-look-item-sku" class="b2b-add-to-cart-content"></div></h4>'
      '<div id="the-look-item-link" class="b2b-add-to-cart-content"></div>'
      '<div id="the-look-item-text" class="b2b-add-to-cart-content"></div>'
    '</div>';
  

      // get_metafield_value(response.handle, 'custom', 'recommended_resale_price').then(value => {
      //     console.log("Metafield value:", value);
      //     $('#the-look-item-rrp').html('RRP: '+value+",- DKK");
      // }).catch(error => {
      //     console.error('Error fetching metafield:', error);
      // });

      if (response.variants.length > 1) {
          var variant_html = "";
          for (let i = 0; i < response.variants.length; i++) {
              element     = response.variants[i];

              var ele_price   = (element.price/100);
              var ele_sku     = element.sku;
              ele_sku.toString();
              var ele_id  = element.id;
              
              console.log(element);
              
              variant_html += '<input type="radio" id="'+ele_id+'" data-sku="'+ele_sku+'" data-price="'+ele_price+'" name="Size" value="'+element.option1+'" checked="">'+
              '<label onclick="change_product_variant('+ele_price+','+ele_sku+','+ele_id+')" for="'+ele_id+'">'+element.option1+'</label>';
            
          }
      }

      console.log('Response ID '+response.variants[0].id);
      //set_inventory_quantity(response.variants[0].id);

      if (variant_html !== null && variant_html !== undefined && variant_html !== "") {
          $('#the-look-item-variants').html(variant_html);
      }
      $('#the-look-item-sku').html('<b>SKU:</b> '+response.variants[0].sku);
      $('#the-look-item-link').html('<a href="/products/'+response.handle+'" target="_blank" title="Åbner i en ny fane" alt="åbner i en ny fane">Gå til produktsiden for '+response.title+'</a>');
      $('#the-look-item-text').html(response.description);
      $('#add-to-cart-btn').attr('data-hande', response.handle);
      $('#add-to-cart-btn').attr('data-id', response.variants[0].id);
    })
    .then( funcData=> {
      // add_to_cart_click();
      // bulk_add_to_cart();
        
    })
    .catch((xhr, status, error) => {
      // Handle error cases here
      if (status == "error") {
          console.log('An error occurred: ' + error+'. <br> status: '+status);
          $('div#add-to-cart-content .right-col').hide();
          $('div#add-to-cart-content .right-col.error-col').show();
          $('div#add-to-cart-content .right-col.error-col').html('<h2>An error occurred</h2>'+
          '<h4>Error: There was a problem getting the product data</h4>'+
          '<br><b>Product sku: '+id+'</b>'+
          '<br><ul><li>Try searching the regular webshop for the product</li>'+
          '<li>Make sure there is no error in the PDF</li></ul>'
          );
        $('#the-look-item-img').html('<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 48 48"><g class="nc-icon-wrapper"><path d="M24 1C11.297 1 1 11.297 1 24C1 36.703 11.297 47 24 47C36.703 47 47 36.703 47 24C46.986 11.303 36.697 1.014 24 1ZM7 24C6.988 14.623 14.581 7.012 23.958 7C27.442 6.996 30.844 8.063 33.7 10.058L10.058 33.7C8.066 30.858 6.999 27.471 7 24ZM24 41C20.529 41.001 17.142 39.934 14.3 37.942L37.942 14.3C43.311 21.988 41.43 32.573 33.742 37.942C30.885 39.937 27.484 41.005 24 41Z" fill="url(#nc-ui-7-0_linear_219_13)"></path> <defs> <linearGradient id="nc-ui-7-0_linear_219_13" x1="24" y1="1" x2="24" y2="47" gradientUnits="userSpaceOnUse"> <stop stop-color="#FF666D"></stop> <stop offset="1" stop-color="#E0211F"></stop> </linearGradient> </defs></g></svg>');
      }
        
    });
  }
}

function afterAddShopTheSet(){
  const addToCartContainer = document.getElementById('add-to-cart-container');
  const addedToCartNotice = document.getElementById('add-to-cart-notice');
   console.log('afterAddShopTheSet called');
  if (addToCartContainer) {
    addToCartContainer.style.display = "none";
  }
  if (addedToCartNotice) {
    addedToCartNotice.style.display = "block";
  }

  // Let other cart components (cart page, quick order list etc.) refresh themselves
  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shop-the-set' });
}

/**
 * Close the shop-the-set pop-up: on the close button, a click on the backdrop, or Escape.
 * Delegated so it works no matter when the pop-up markup is rendered.
 */
document.addEventListener('click', function(event) {
  const closeButton = event.target.closest('[id="add-to-cart-container"] .close');
  const backdrop = event.target.id === 'add-to-cart-container' ? event.target : null;
  const container = closeButton ? closeButton.closest('[id="add-to-cart-container"]') : backdrop;
  if (container) {
    container.style.display = 'none';
  }
});

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[id="add-to-cart-container"]').forEach(function(container) {
    container.style.display = 'none';
  });
});

/**
 * Re-render the cart drawer and the cart icon bubble so the customer can see the added items.
 * Opens the drawer when the theme uses one.
 */
async function refreshCartUI() {
  const cartDrawer = document.querySelector('cart-drawer');
  const sectionIds = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const response = await fetch(`${root}?sections=${sectionIds.join(',')}`);
  const sections = await response.json();

  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    cartDrawer.classList.remove('is-empty');
    // renderContents updates both the drawer and the cart icon bubble, then opens the drawer
    cartDrawer.renderContents({ sections: sections });
    return;
  }

  const bubble = document.getElementById('cart-icon-bubble');
  if (bubble && sections['cart-icon-bubble']) {
    const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    const newBubble = html.querySelector('.shopify-section');
    if (newBubble) bubble.innerHTML = newBubble.innerHTML;
  }
}

/**
 * Toggle the theme's loading spinner on a button
 */
function setButtonLoading(button, isLoading) {
  let spinner = button.querySelector('.loading-overlay__spinner');
  if (!spinner) {
    spinner = document.createElement('div');
    spinner.className = 'loading-overlay__spinner hidden';
    spinner.innerHTML =
      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
      '</svg>';
    button.appendChild(spinner);
  }

  button.classList.toggle('loading', isLoading);
  spinner.classList.toggle('hidden', !isLoading);
  button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  button.style.pointerEvents = isLoading ? 'none' : '';
}

/**
 * Bulk add items to cart
 */
document.addEventListener("click", async function(event) {
  const button = event.target.closest('#add-to-cart-btn');
  if (!button || button.classList.contains('loading')) return;

  // Read the currently selected sizes directly from the form, so the choice is never out of date.
  // Falls back to data-id for buttons without shop-the-set markup (e.g. the PDF catalogue).
  const container = button.closest('[id="add-to-cart-container"]');
  let variantIds = container ? getSelectedVariantIdsInContainer(container) : null;
  if (!variantIds) {
    const dataIdString = button.getAttribute('data-id') || '';
    variantIds = dataIdString.split(',').map(id => id.trim()).filter(Boolean);
  }

  let itemsToAdd = [];


  
  variantIds.forEach(variantId => {
    // Example: find corresponding input by some means, like a data attribute or id
    // This is an assumed step, you'll need to adjust based on your actual HTML structure
    // const input = document.querySelector(`[data-variant-id="${variantId}"]`);

    // if (input) {
      // let quantity = parseInt(input.value);
      let quantity = 1;

      if (quantity > 0) {
          itemsToAdd.push({
              id: variantId,
              quantity: quantity
          });
      }
    // }
  });

  if (itemsToAdd.length === 0) {
    // Handle case where there are no items to add
    console.log('No products to add to cart.');
    alert("Du har ikke valgt nogle produkter endnu");
    return; // Exit the function early
  }

  console.log('Adding');
  console.log(itemsToAdd);
  setButtonLoading(button, true);
  try {
      const results = await bulkAddToCart(itemsToAdd);
      const failed = results.filter(result => !result || result.status);
      console.log("Items added:", results);

      if (failed.length < results.length) {
        afterAddShopTheSet();
        await refreshCartUI();
      }

      if (failed.length > 0) {
        // Shopify returns { status, message, description } for items that could not be added (e.g. out of stock)
        alert(failed.map(result => (result && result.description) || 'Et produkt kunne ikke lægges i kurven').join('\n'));
      }
  } catch (error) {
      console.error("Error adding items to cart:", error);
  } finally {
      setButtonLoading(button, false);
  }
});

/**
 * Function to add items to cart through the shop the set 
 * @param {*Array} items 
 * @returns 
 */
async function bulkAddToCart(items) {
  let cartAddURL = '/cart/add.js';
  let results = [];

  for (let item of items) {
      try {
          let response = await fetch(cartAddURL, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  id: item.id,
                  quantity: item.quantity
              })
          });

          // Convert the individual response to JSON
          let json = await response.json();
          results.push(json);
      } catch (error) {
          console.error("Error adding item to cart:", item.id, error);
      }
  }

  return results;
}

function add_to_cart_click(){
  $('#add-to-cart-btn').on('click', function(){
      var item_quantity = parseFloat($('input#Quantity-catalogue').val());
      var item_handle = $(this).attr('data-handle');
      var item_id = $(this).attr('data-id');

      console.log('item id: ' +item_id);
      console.log('item quantity: ' + item_quantity);

      let formData = {
      'items': [{
          'id': item_id,
          'quantity': item_quantity
          }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => {
          return response.json();
      })
      .then(response => {
          console.log(response);
          $('#the-look-item-status').html('Product added to cart!<br> <b><a stle="text-decoration: underline;" href="/cart" target="_blank">Go to cart</a></b>');
      })
      .catch((error) => {
          $('#the-look-item-status').html('There was en error adding '+response.title+' to cart!<br>'+error);
          console.log('Error adding product');
      });
  });
}


/**
 * Get product data to find selected variant and insert into add-to-cart-btn
 */
function fetchProductDataAndFindVariant() {
  // Each shop-the-set container has its own button, so resolve variants per container
  document.querySelectorAll('[id="add-to-cart-container"]').forEach(function(container){
    var button = container.querySelector('#add-to-cart-btn');
    var variantIds = getSelectedVariantIdsInContainer(container);
    if (button && variantIds) {
      button.setAttribute('data-id', variantIds.join(','));
    }
  });
}

/**
 * Resolve the selected variant id for every product in a shop-the-set container,
 * using the variant JSON rendered in product-hot-spots.liquid.
 * Returns null if the container has no shop-the-set products or a product can't be resolved.
 */
function getSelectedVariantIdsInContainer(container) {
  var contents = container.querySelectorAll('.add-to-cart-content');
  if (contents.length === 0) return null;

  var variantIds = [];
  for (var form of contents) {
    var defaultVariantId = form.getAttribute('data-variant-id');
    var optionsForm = form.querySelector('.options-form');
    var variantsJson = optionsForm && optionsForm.querySelector('.js-product-variants');

    // Products with only a default variant have no options form
    if (!variantsJson) {
      if (!defaultVariantId) return null;
      variantIds.push(defaultVariantId);
      continue;
    }

    var selectedOptions = getSelectedVariantIDs(optionsForm);
    var selectedVariant = findSelectedVariant(JSON.parse(variantsJson.textContent), selectedOptions);
    console.log('Selected variant: ', selectedVariant);
    if (selectedVariant) {
      variantIds.push(String(selectedVariant.id));
    } else if (defaultVariantId) {
      console.log('No matching variant found');
      variantIds.push(defaultVariantId);
    } else {
      return null;
    }
  }

  return variantIds;
}


/**
* Get the selected option values
* @returns 
*/
function getSelectedVariantIDs(variant_radios_element) {
  var variantIDs = [];
  // Assuming each group of radio buttons is wrapped in a .variant_options container
  if (variant_radios_element) {
    var optionGroups = variant_radios_element.querySelectorAll('.variant_options');
    optionGroups.forEach(function(group) {
      // Find all checked radio buttons within this group
      
      group.querySelectorAll('input').forEach(function(item){
        if (item.checked == true) {
          console.log(item.value);
          var variantID = item.value;
          variantIDs.push(variantID);
        }
      })
      // var checkedRadios = group.querySelectorAll('input[type="radio"]:checked');
      // checkedRadios.forEach(function(radio) {
      //   var variantID = radio.value;
      //   variantIDs.push(variantID);
      // });
    });
  }
  
  return variantIDs;
}

// /**
//  * Get the selected <select></select> values
//  * @returns 
//  */
// function getSelectedVariantIDs() {
//   var variantIDs = [];
//   var selectElements = document.querySelectorAll('.variant-options');
//   selectElements.forEach(function(select) {
//       var selectedOption = select.options[select.selectedIndex];
//       var variantID = selectedOption.value;
//       variantIDs.push(variantID);
//   });
//   return variantIDs;
// }



/**
* Get the selected variant id
* @param {*} variants 
* @param {*} selectedOptions 
* @returns 
*/
function findSelectedVariant(variants, selectedOptions) {
  return variants.find(variant => {
      return Object.entries(selectedOptions).every(([optionName, optionValue]) => {
          var optionIndex = variant.options.indexOf(optionValue);
          return optionIndex !== -1 && variant[`option${optionIndex + 1}`] === optionValue;
      });
  });
}


/**
 * Get variant stock data and set data in shop the set pop
 * @param {*String} variant_id 
 */
function set_inventory_quantity(variant_id){
  const phpEndpoint = "https://shopify.api.nomilk.dev/inventory-data.php";


  console.log('The recieved ID');
  console.log(variant_id);

  fetch(phpEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ variantId: variant_id })    
  })
  .then(response => {
    console.log('response');
    console.log(response);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // The graphQL result
    console.log(data);
    const graphQLResult = data.data.productVariant.inventoryItem.inventoryLevels.edges[0].node.available;
    const locationInventory = {};

    if( Array.isArray(graphQLResult) ){
      // Extract the ID from the GID
      // Make a new object array
      graphQLResult.forEach(item => {
          console.log(item.node.available);
      });
    }
    console.log('Inventory: '+ graphQLResult);
    const inventoryItem = document.getElementById('the-look-item-inventory');

    if( graphQLResult > 0 ) {
      inventoryItem.innerHTML = 
      '<div class="js-variant-inventory-data inventory-element in-stock" data-id="{{ variant.id }}" data-quantity="{{ variant.inventory_quantity | default: 0 }}" >'+
      '<span class="inventory-color in-stock"></span>'+
      '<span class="inventory-text">På lager</span>'+
      '</div>';
    }else{
      inventoryItem.innerHTML = 
      '<div class="js-variant-inventory-data inventory-element in-stock" >'+
      '<span class="inventory-color out-of-stock"></span>'+
      '<span class="inventory-text">I restordre - Forvent længere leveringstid</span>'+
      '</div>';
    }
    
  })
  .then( () => {
    console.log('inside then');
    console.log('Done then');
  })
  .catch(error => {
    console.error('There was a problem fetching the inventory data:', error);
  });
}



window.addEventListener('load', function(e){
  hotspot_functionality();
  //display_inventory_data();

  var variant_labels = document.querySelectorAll('.variant_options label');

  variant_labels.forEach(function(label) {
    label.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default link action
      console.log('control: ',label.control);
      console.log('control type: ',label.control.type);

      // This step is necessary only to uncheck all other radio buttons in a group
      if (label.control && label.control.type === 'radio') {
        console.log('control: ',label.control);
        console.log('control type: ',label.control.type);
        document.querySelectorAll('input[name="' + label.control.name + '"]').forEach(function(input) {
          console.log('label control name: '+label.control.name);
          input.checked = false; // Uncheck all radios in the same group
        });
      }
  
      let label_id = this.getAttribute('for');
      let label_input = document.getElementById(label_id);
  
      if (label_input) {
        label_input.checked = true; // Directly set the checked property to true
        console.log('Label input item ', label_input);
        console.log('label ID ', label_id);
  
        setTimeout(() => {
          fetchProductDataAndFindVariant();
        }, 200);
      }
    });
  });
  
  // Functionality for checkbox on cart page
  // const inputFields = document.querySelectorAll('.check-input'); 
  // const checkOutBtns = document.querySelectorAll('.custom_checkout');

  // if (inputFields.length > 0 && checkOutBtns.length > 0) {
  //   function toggleButtonState() {
  //       inputFields.forEach(function(inputItem) {
  //           checkOutBtns.forEach(function(checkBtn) {
  //               if (inputItem.checked) {
  //                   checkBtn.classList.add('active');
  //                   checkBtn.style.opacity = "1";
  //                   checkBtn.style.pointerEvents = "all";
  //               } else {
  //                 checkBtn.classList.remove('active');
  //                   checkBtn.style.opacity = "0.5"; 
  //                   checkBtn.style.pointerEvents = "none"; 
  //               }
  //           });
  //       });
  //   }

  //   toggleButtonState(); 

  //   // Attach the event listener to each checkbox
  //   inputFields.forEach(function(inputItem) {
  //       inputItem.addEventListener('change', toggleButtonState);
  //   });
  // }


  fetchProductDataAndFindVariant();

  
});


window.addEventListener('load', function () {
  console.log('LOAD');
  const cartForm = document.querySelector('cart-drawer-items');

  function toggleButtonState() {
    const inputFields = document.querySelectorAll('.check-input'); // re-select each time
    const allChecked = Array.from(inputFields).every(input => input.checked);
    const checkOutBtns = document.querySelectorAll('.custom-checkout');
    console.log('check toggle state');
    checkOutBtns.forEach(checkBtn => {
      if (allChecked) {
        checkBtn.classList.add('active');
        checkBtn.style.opacity = "1";
        checkBtn.style.pointerEvents = "all";
      } else {
        checkBtn.classList.remove('active');
        checkBtn.style.opacity = "0.5";
        checkBtn.style.pointerEvents = "none";
      }
    });
  }

  // Initial state check
  toggleButtonState(); 


  // Use event delegation for checkbox changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('.check-input')) {
      console.log('event delegation');
      toggleButtonState();
    }
  });

  function observeCartChanges() {
    console.log('function observe');
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if(entry.initiatorType == 'fetch'){
          console.log('Entry: ', entry);
        }
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          console.log('_____CART CHANGE______');
          // handle cart request
          toggleButtonState();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }

  observeCartChanges();
});
